var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeExperienceFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 49,
    viewBox: "0 0 34 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67697 48.073C0.760225 48.073 0 47.3128 0 46.3961V1.67697C0 0.760225 0.760225 0 1.67697 0C2.59371 0 3.35393 0.760225 3.35393 1.67697V46.3961C3.35393 47.3128 2.59371 48.073 1.67697 48.073Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7197 34.6573H1.67697C0.760225 34.6573 0 33.8971 0 32.9803C0 32.0636 0.760225 31.3034 1.67697 31.3034H26.7197C29.1569 31.3034 30.2972 30.655 30.5208 30.096C30.7444 29.537 30.409 28.2848 28.665 26.5632L25.9818 23.88C24.8862 22.9186 24.2154 21.4652 24.1483 19.8553C24.0813 18.156 24.752 16.479 25.9818 15.2492L28.665 12.5661C30.3196 10.9115 30.8338 9.5699 30.5879 8.98855C30.3419 8.4072 29.0674 7.82586 26.7197 7.82586H1.67697C0.737865 7.82586 0 7.06563 0 6.14889C0 5.23215 0.760225 4.47192 1.67697 4.47192H26.7197C31.6164 4.47192 33.1816 6.50664 33.6959 7.71406C34.1878 8.92147 34.5232 11.4705 31.0351 14.9586L28.3519 17.6417C27.7929 18.2007 27.4799 18.9833 27.5023 19.7659C27.5246 20.4366 27.7929 21.0403 28.2625 21.4652L31.0351 24.2154C34.4561 27.6364 34.1207 30.1854 33.6288 31.4152C33.1145 32.6002 31.527 34.6573 26.7197 34.6573Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeExperienceFlag);
export default __webpack_public_path__ + "static/media/intake-experience-flag.908c079a417d37e4ef92e5be124761ef.svg";
export { ForwardRef as ReactComponent };